import { translate } from '../ContentTranslation';
import './App.css';
import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Home from './home/Home';
import Error from './home/Error';
import Loading from './home/Loading';
import Play from './play/Play';
import Story from './play/story/Story';
import Game from './play/game/Game';
import Cards from './play/cards/Cards';
import Items from './play/items/Items';
import Gallery from './play/gallery/Gallery';
import Progress from './play/progress/Progress';
import Milestones from './play/milestones/Milestones';
import Pantheon from './play/pantheon/Pantheon';
import AgeCheck from './home/AgeCheck';
import PatreonRedirect from './patreon/PatreonRedirect';
import User from '../User';
import StoryText from './text/StoryText';
import Flowers from './other/flowers/Flowers';

import { read, getLanguage, setLanguage } from '../TextManager';

export default class App extends Component {

  constructor (props) {

    super(props);
    this.home = React.createRef();

    //setTimeout(() => this.setState({started: true}), 300)

    this.state = {
      ageCheck: sessionStorage.getItem("agecheck"),
      premium: User.premium,
      started: false
    };

    let reloadLanguage = false;
    switch (window.location.pathname) {
    case '/en': if (getLanguage() !== "en") reloadLanguage = true; setLanguage('en'); break;
    case '/fr': if (getLanguage() !== "fr") reloadLanguage = true; setLanguage('fr'); break;
    case '/jp': if (getLanguage() !== "jp") reloadLanguage = true; setLanguage('jp'); break;
    default: break;
    }

    if (reloadLanguage)
      window.location.reload(false);
  }

  async componentDidMount() {
    const premium = this.state.premium ? true : await this.checkPatreonToken();
    this.setState({ premium, started: true });
  }

  checkPatreonToken = async () => {
    const token = localStorage.getItem("patreon.token");
    if (!token) return false;

    try {
      const response = await fetch(`/.netlify/functions/patreon-check?token=${encodeURIComponent(token)}`);
      const data = await response.json();
      if (data.error || !data.elite) {
        localStorage.removeItem("patreon.token");
        return false;
      }

      User.unlockPremium();
      return true;
    } catch {
      localStorage.removeItem("patreon.token");
      return false;
    }
  }

  render () {

    let premium = this.state.premium || User.premium;

    if (!this.state.started)
      return <Loading value={this.state.loading}/>;

    if (!this.state.ageCheck && !window.location.pathname.startsWith("/oauth"))
      return <div className="app"><AgeCheck onCheck={() => {
        sessionStorage.setItem("agecheck", true);
        this.setState({ageCheck: true});
      }}/></div>

    let characterAccess = User.contentLimits(User.champion).level > 0;

    return (
      <div className="app">
        <Router>
          <Routes>
            <Route path="/" element={<Dynamo premium={premium}><Play/></Dynamo>}/>
            { characterAccess && <Route path="/story" element={<Dynamo premium={premium}><Story/></Dynamo>}/> }
            { characterAccess && <Route path="/game" element={<Dynamo premium={premium}><Game/></Dynamo>}/> }
            { characterAccess && <Route path="/collection" element={<Dynamo premium={premium}><Cards/></Dynamo>}/> }
            { characterAccess && <Route path="/gallery" element={<Dynamo premium={premium}><Gallery/></Dynamo>}/> }
            { characterAccess && <Route path="/pantheon" element={<Dynamo premium={premium}><Pantheon/></Dynamo>}/> }
            { characterAccess && <Route path="/traits" element={<Navigate to="/pantheon" replace />}/> }
            { characterAccess && <Route path="/milestones" element={<Dynamo premium={premium}><Milestones/></Dynamo>}/> }
            { characterAccess && <Route path="/progress" element={<Dynamo premium={premium}><Progress/></Dynamo>}/> }
            <Route path="/oauth" element={<Dynamo premium={premium}><PatreonRedirect/></Dynamo>}/>
            <Route
                path="*"
                element={<Navigate to="/" replace />}
            />
          </Routes>
        </Router>
      </div>
    );
  }
}

var checkLibraryVersion = false;

class Dynamo extends Component {

  constructor (props) {

    super(props);

    setTimeout(() => {
      if (!this.state.loaded) {
        this.showLoadingScreenFade = true;
        if (this.state.loaded)
          this.setState({loaded:false});
      }
    }, 500)

    /*this.state = {
      loading: 0,
      loaded: false
    }*/

    if (localStorage.getItem("patreon.token")) {
      
      this.state = {
        loading: 0,
        loaded: false
      }

      this.checkPatreonToken();

    } else 
      this.state = {
        loading: 0,
        loaded: true
      }
  }

  checkPatreonToken = async () => {

    try {
        const response = await fetch(`/.netlify/functions/patreon-check?token=${encodeURIComponent(localStorage.getItem("patreon.token"))}`);
        const data = await response.json();

        if (data.error) {
          localStorage.removeItem("patreon.token");
          this.setState({ loaded: true });
        } else {
          if (data.elite)
            User.unlockPremium();
          else
            localStorage.removeItem("patreon.token");
          this.setState({ loaded: true });
        }
      } catch (error) {
          localStorage.removeItem("patreon.token");
          this.setState({ loaded: true });
      }
  }

  render () {

    if (!this.state.loaded)
      return <Loading value={this.state.loading}>{translate("Checking Patreon status")}</Loading>;

    return this.props.children;
  }
}

